import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@/locales/en.json";
import hi from "@/locales/hi.json";
import te from "@/locales/te.json";
import ta from "@/locales/ta.json";
import de from "@/locales/de.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import zh from "@/locales/zh.json";
import ja from "@/locales/ja.json";
import ar from "@/locales/ar.json";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English", group: "suggested", rtl: false },
  // Indian
  { code: "hi", label: "Hindi", native: "हिन्दी", group: "indian", rtl: false },
  { code: "te", label: "Telugu", native: "తెలుగు", group: "indian", rtl: false },
  { code: "ta", label: "Tamil", native: "தமிழ்", group: "indian", rtl: false },
  // Global
  { code: "de", label: "German", native: "Deutsch", group: "global", rtl: false },
  { code: "fr", label: "French", native: "Français", group: "global", rtl: false },
  { code: "it", label: "Italian", native: "Italiano", group: "global", rtl: false },
  { code: "zh", label: "Chinese", native: "中文", group: "global", rtl: false },
  { code: "ja", label: "Japanese", native: "日本語", group: "global", rtl: false },
  { code: "ar", label: "Arabic", native: "العربية", group: "global", rtl: true },
];

export const RTL_LANGS = LANGUAGES.filter((l) => l.rtl).map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      te: { translation: te },
      ta: { translation: ta },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      zh: { translation: zh },
      ja: { translation: ja },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "stb_language",
      caches: ["localStorage"],
    },
  });

export const applyLanguageDir = (lng) => {
  const rtl = RTL_LANGS.includes(lng);
  document.documentElement.setAttribute("dir", rtl ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
};

i18n.on("languageChanged", applyLanguageDir);
applyLanguageDir(i18n.language);

export default i18n;
